import store from '@/store';
import mixedModeHelper from '../../../views/genetic-similarities/services/mixedModeHelper';

import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

const DataWatcherService = {
  unwatchers: [],

  async init() {
    await this.loadMixedModeResults();
    this.watchTwoWayPeriodState();
    this.watchThreeWayPeriodState();
  },

  watchTwoWayPeriodState() {
    const unwatch = store.watch(
      (state) => state.mixedModePeriod.selectedTwoWayPeriod,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.runTwoWayResult();
        }
      }
    );
    
    this.unwatchers.push(unwatch);
  },

  watchThreeWayPeriodState() {
    const unwatch = store.watch(
      (state) => state.mixedModePeriod.selectedThreeWayPeriod,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.runThreeWayResult();
        }
      }
    );
    
    this.unwatchers.push(unwatch);
  },

  async runTwoWayResult() {
    try {
      if (!(store.state.mixedModePeriod.selectedTwoWayPeriod)) {
        return;
      }

      const solvedResults = this.getCurrentTwoWayResult();
      
      const listOfSourceData = solvedResults.flatMap(item => item.pops.map(pop => pop.name));
      const uiDetailDataResult = await store.dispatch('mixedModeResult/fetchAncientDetails', listOfSourceData);
      if (!uiDetailDataResult) {
        return;
      }
      
      solvedResults.forEach(item => {
        item.pops.forEach(resultItem => {
          resultItem.isAncient = true;
          resultItem.tname = resultItem.name.replaceAll('*', ' ');
  
          const detailItem = uiDetailDataResult.find(x => x.sourceCode === resultItem.name);
          if (detailItem) {
            resultItem.id = detailItem.id;
            resultItem.logoUrl = detailItem.logoUrl;
            resultItem.sourceCode = detailItem.sourceCode;
          }
        });
      });
      store.commit('mixedModeResult/setUiResultsTwoWay', solvedResults);
    } catch (error) {
      console.error('Error handling specific state change:', error);
    }
  },

  getCurrentTwoWayResult() {
    const periodId = store.state.mixedModePeriod.selectedTwoWayPeriod.guid;
    let result = store.state.mixedModeResult.twoWayResults[periodId];
   
    if (result) {
      return result;
    } else {
      const periodResult = store.state.mixedModeResult.results.find(x => x.periodId === periodId);
      if(periodResult.twoWayResult) {
        result = mixedModeHelper.MixedModeRunTwoWay(periodResult.twoWayResult);
        store.state.mixedModeResult.twoWayResults[periodId] = result;
      }
    }
    return result;
  },

  async runThreeWayResult() {
    try {
      if (!(store.state.mixedModePeriod.selectedThreeWayPeriod)) {
        return;
      }

      const solvedResults = this.getCurrentThreeWayResult();
      const listOfSourceData = solvedResults.flatMap(item => item.pops.map(pop => pop.name));
      const uiDetailDataResult = await store.dispatch('mixedModeResult/fetchAncientDetails', listOfSourceData);

      if (!uiDetailDataResult) {
        return;
      }
      
      solvedResults.forEach(item => {
        item.pops.forEach(resultItem => {
          resultItem.isAncient = true;
          resultItem.tname = resultItem.name.replaceAll('*', ' ');
  
          const detailItem = uiDetailDataResult.find(x => x.sourceCode === resultItem.name);
          if (detailItem) {
            resultItem.id = detailItem.id;
            resultItem.logoUrl = detailItem.logoUrl;
            resultItem.sourceCode = detailItem.sourceCode;
          }
        });
      });
      store.commit('mixedModeResult/setUiResultsThreeWay', solvedResults);
    } catch (error) {
      console.error('Error handling specific state change:', error);
    }
  },

  getCurrentThreeWayResult() {
    const periodId = store.state.mixedModePeriod.selectedThreeWayPeriod.guid;
    
    let result = store.state.mixedModeResult.threeWayResults[periodId];
   
    if (result) {
      return result;
    } else {
      const periodResult = store.state.mixedModeResult.results.find(x => x.periodId === periodId);
      if(periodResult.threeWayResult) {
        result = mixedModeHelper.MixedModeRunThreeWay(periodResult.threeWayResult);
        store.state.mixedModeResult.threeWayResults[periodId] = result;
      }
    }
    return result;
  },

  async loadMixedModeResults() {
    const response = await communicationService.requestData({ key: dataKeys.GET_MIXEDMODE_RESULT });
    if (response.result_data) {
      const data = JSON.parse(response.result_data.replace(/\r\n/g, '\\r\\n'));
      store.commit('mixedModeResult/setResults', data);
    }
  },

  cleanup() {
    this.unwatchers.forEach(unwatch => unwatch());
    this.unwatchers = [];
  },
};

export default DataWatcherService;
